import { useNavigate } from "react-router-dom";

import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { grey } from "@mui/material/colors";

import { rootProtectedPath, services } from "data/authData";
import { refundTrackerServices } from "./data";

const serviceBox = {
	display: "flex",
	p: 2,
	alignItems: "center",
	columnGap: "20px",
	border: "1px solid var(--grayBgColor)",
	borderRadius: 2,
	margin: "5px 0px",
	sx: { "&:hover": { boxShadow: 1 }, cursor: "pointer" },
};

const RefundTrackerExplore = () => {
	const navigate = useNavigate();

	const handleServiceClick = (path) => {
		navigate(`/${rootProtectedPath}/${services.refund_tracker.path}/${path}`);
	};

	return (
		<Box maxWidth="1200px" margin="auto">
			<Box display="flex" columnGap="20px" alignItems="center">
				<Typography sx={{ width: "100%", margin: "auto" }} pt={2} pb={2} variant="h4">
					Refund Tracker
				</Typography>
			</Box>
			<Stack width={{ xs: "90%", sm: "100%" }} margin="auto" direction="row" flexWrap="wrap">
				{refundTrackerServices &&
					Object.keys(refundTrackerServices).map((key) => {
						const service = refundTrackerServices[key];
						return (
							<Box display="flex" flexWrap="wrap" key={service.name} columnGap={2}>
								<Typography sx={{ width: "100%", margin: "auto" }} pt={2} variant="subtitle1" color={grey[400]}>
									{service.name}
								</Typography>
								{service?.types &&
									Object.keys(service.types)
										.reduce((acc, row) => {
											if (service.types[row].display) acc.push(service.types[row]);
											return acc;
										}, [])
										.map((row) => (
											<Box key={row.name} onClick={() => handleServiceClick(row.key)} {...serviceBox}>
												{row.icon}
												<Typography variant="h6">{row.name}</Typography>
											</Box>
										))}
								{!service?.types && (
									<Box key={service.name} onClick={() => handleServiceClick(service.key)} {...serviceBox}>
										{service.icon}
										<Typography variant="h6">{service.name}</Typography>
									</Box>
								)}
							</Box>
						);
					})}
			</Stack>
		</Box>
	);
};

export default RefundTrackerExplore;
